var r = /* @__PURE__ */ ((R) => (R.ERROR = "ERROR", R.SUCCESS = "SUCCESS", R.TIP = "TIP", R.WARNING = "WARNING", R))(r || {});
export {
  r as TextInputMessageStatus
};
